'use strict';

import analytics from '../analytics';
import dialog from '../dialog';
import modal from '../modal';
import quickview from '../quickview';
import minicart from '../minicart';
import tooltip from '../tooltip';
import validator from '../validator';
import tls from '../tls';
// import afterpay from '../afterpay';
import headerMenu from '../header-menu';
import footerSelector from '../footer-selector';
import newsletter from '../newsletter';
import inputEntry from '../input-entry';
import wishlists from '../pages/beautystation/wishlists';
import deTheme from '../theme';
import login from '../login';
import newsletterModule from '../newsletter-module';
import skiplinks from '../skiplinks';

import main from '../main';

import jqueryExt from '../jquery-ext';
import cookieprivacy from '../cookieprivacy';
import captcha from '../captcha';

import '../spritespin';

jqueryExt();
cookieprivacy();
captcha();

import cart from '../pages/cart';
// import checkout from '../pages/checkout';
// import singlepagecheckout from '../pages/singlepagecheckout';
import orderconfirmation from '../pages/order-confirm';
import error from '../pages/error';
// import checkgiftbalance from '../pages/checkgiftbalance';

const pages = {
  cart,
  orderconfirmation,
  error
};


var app = {
    /**
     * Initialization of storefront logic
     */
    init: function () {

        $(document).foundation();

        if (document.cookie.length === 0) {
            $('<div></div>').addClass('browser-compatibility-alert').append($('<p></p>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        main.init();
        main.initializeDom();
        main.initializeEvents();
        main.backToTopHandler();
        main.minimizedHeaderHandler();
        main.responsiveMegaMenu();
        main.searchMenuEvent();
        login.init();
        newsletterModule.init();

        // init specific global components
        analytics.init();
        tooltip.init();
        if ($('.pt_checkout').length === 0) {
            minicart.init();
        }
        validator.init();
        headerMenu.init();
        skiplinks.init();
        if (SitePreferences.IS_MARKET_MAPPING_ENABLED) {
            footerSelector.languageSelector();
            footerSelector.countrySelector();
        }

        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        newsletter.signUpFooter();
        
        inputEntry.entry();
        main.playVideoHandler();

        deTheme.init();

        if(SitePreferences.WEBSITE_COUNTRY_CODE == 'CA'){
            main.validatorForDECA();
        }

        main.initPageSpecificModule(pages);

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

        // if (SitePreferences.AFTERPAY_ENABLED) {
        //     afterpay.init();
        // }

        $('body').trigger('showNewsletterModal');
        wishlists.initPDPAndCartEvents();
    }
};

// initialize app
$(function () {
    app.init();
});

// expose global app obj for 3rd party integrations
window.app = {
    quickView: quickview,
    minicart: minicart,
    modal: modal,
    dialog: dialog,
    user: window.User,
    SCemailUrl: window.Urls.SCemailUrl,
    Product: {},
    tagmanager: analytics.tagmanager,
    gtmInternalPromotion: analytics.gtmInternalPromotion,
    deTheme: deTheme
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = main.addSummaryScrollbar;
window.scrollToTop = main.scrollToTop;
